export const isSupported: boolean = (() => {
  try {
    const itemBackup = localStorage.getItem('');
    localStorage.removeItem('');
    localStorage.setItem('', itemBackup);
    if (itemBackup === null) localStorage.removeItem('');
    else localStorage.setItem('', itemBackup);
    return true;
  } catch (e) {
    return false;
  }
})();

/**
 * Check if localStorage has an Item / exists with the give key
 * @param key the key of the Item
 */
export function hasItem(key: string): boolean {
  return localStorage.getItem(key) !== null;
}
